export const defaultColors: Array<string> = [
  '#1a1d39',
  '#e26126',
  '#7351ba',
  '#ffa600',
  '#00d084',
];
